/* IOI - Veterans Day 2026 free hat: auto add / remove / color swap.
   Config comes from window.IOI_VD (rendered in layout/theme.liquid from theme settings). */
(function () {
  var C = window.IOI_VD;
  if (!C || window.__ioiVdBound) return;
  window.__ioiVdBound = true;

  var origFetch = window.fetch.bind(window);
  var KEY = 'ioiVdHatDeclined';
  var busy = false;
  var timer = null;
  var lastCart = null;

  function declined() { try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; } }
  function setDeclined(v) { try { if (v) sessionStorage.setItem(KEY, '1'); else sessionStorage.removeItem(KEY); } catch (e) {} }
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function json(r) { return r.json(); }
  function post(path, body) {
    return origFetch(root() + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then(json);
  }
  function isGift(item) { return item && item.product_id === C.productId && item.properties && item.properties._ioi_vd_gift; }
  function pickVariant() {
    var best = null;
    for (var i = 0; i < C.variants.length; i++) {
      var v = C.variants[i];
      if (v.a && (!best || v.q > best.q)) best = v;
    }
    return best ? best.id : null;
  }
  function addGift(variantId) {
    return post('cart/add.js', { items: [{ id: variantId, quantity: 1, properties: { _ioi_vd_gift: 'Veterans Day free hat' } }] });
  }
  function setQty(key, qty) { return post('cart/change.js', { id: key, quantity: qty }); }

  function syncCart() {
    return origFetch(root() + 'cart.js', { headers: { Accept: 'application/json' } }).then(json).then(function (c) { lastCart = c; }).catch(function () {});
  }

  function refresh() {
    syncCart();
    if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return Promise.resolve(); }
    return origFetch(root() + '?sections=cart-drawer,cart-icon-bubble').then(json).then(function (s) {
      var parser = new DOMParser();
      if (s['cart-drawer']) {
        var doc = parser.parseFromString(s['cart-drawer'], 'text/html');
        var fresh = doc.querySelector('#CartDrawer');
        var current = document.querySelector('#CartDrawer');
        var drawer = document.querySelector('cart-drawer');
        if (fresh && current) {
          current.innerHTML = fresh.innerHTML;
          var overlay = current.querySelector('#CartDrawer-Overlay');
          if (overlay && drawer && typeof drawer.close === 'function') overlay.addEventListener('click', drawer.close.bind(drawer));
          var freshDrawer = doc.querySelector('cart-drawer');
          if (drawer && freshDrawer) drawer.classList.toggle('is-empty', freshDrawer.classList.contains('is-empty'));
        }
      }
      if (s['cart-icon-bubble']) {
        var bubble = document.getElementById('cart-icon-bubble');
        var nb = parser.parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        if (bubble && nb) bubble.innerHTML = nb.innerHTML;
      }
    });
  }

  function check() {
    if (busy) return;
    busy = true;
    origFetch(root() + 'cart.js', { headers: { Accept: 'application/json' } }).then(json).then(function (cart) {
      lastCart = cart;
      var qual = 0, gift = null, anyHat = false;
      for (var i = 0; i < cart.items.length; i++) {
        var it = cart.items[i];
        if (it.product_id === C.productId) { anyHat = true; if (isGift(it)) gift = it; }
        else qual += it.final_line_price;
      }
      var unlocked = qual >= C.threshold;
      var action = null;
      if (unlocked && !gift && !anyHat && C.auto && !declined()) {
        var v = pickVariant();
        if (v) action = addGift(v);
      } else if (!unlocked && gift) {
        action = setQty(gift.key, 0);
      } else if (gift && gift.quantity > 1) {
        action = setQty(gift.key, 1);
      }
      return action ? action.then(refresh) : null;
    }).catch(function () {}).then(function () { busy = false; });
  }
  function schedule(ms) { clearTimeout(timer); timer = setTimeout(check, ms || 300); }

  function findLine(cart, body) {
    if (!cart || !body) return null;
    if (body.line) return cart.items[parseInt(body.line, 10) - 1] || null;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (it.key === body.id || String(it.variant_id) === String(body.id)) return it;
    }
    return null;
  }

  // Watch every cart request on the page (theme drawer, product form, upsell apps) without touching their code.
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch(input, init);
    if (/\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
      try {
        if (/\/cart\/change/.test(url) && init && typeof init.body === 'string') {
          var b = JSON.parse(init.body);
          if (String(b.quantity) === '0' && isGift(findLine(lastCart, b))) setDeclined(true);
        }
      } catch (e) {}
      p.then(function () { schedule(350); }, function () {});
    }
    return p;
  };

  document.addEventListener('click', function (e) {
    var colorBtn = e.target.closest('[data-ioi-vd-color]');
    var addBtn = e.target.closest('[data-ioi-vd-add]');
    if (!colorBtn && !addBtn) return;
    e.preventDefault();
    var box = e.target.closest('[data-ioi-vd-cart]');
    if (box) box.setAttribute('aria-busy', 'true');
    if (addBtn) {
      setDeclined(false);
      var v = pickVariant();
      if (v) addGift(v).then(refresh); else if (box) box.removeAttribute('aria-busy');
      return;
    }
    var newId = parseInt(colorBtn.getAttribute('data-ioi-vd-color'), 10);
    if (colorBtn.classList.contains('is-active')) { if (box) box.removeAttribute('aria-busy'); return; }
    origFetch(root() + 'cart.js', { headers: { Accept: 'application/json' } }).then(json).then(function (cart) {
      var gift = null;
      for (var i = 0; i < cart.items.length; i++) if (isGift(cart.items[i])) gift = cart.items[i];
      return (gift ? setQty(gift.key, 0) : Promise.resolve()).then(function () { return addGift(newId); });
    }).then(refresh).catch(function () { if (box) box.removeAttribute('aria-busy'); });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { schedule(800); });
  else schedule(800);
})();
